var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoubt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#doubt_svg__clip0_2637_47691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53 31c0 13.782-11.153 24.96-24.926 25 0 0-25.074-25.145-25.073-25.218C3.118 17.076 14.266 6 28.001 6c13.806 0 25 11.193 25 25z",
    fill: "#8DB8D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.037 26.97l9.003.491s.437-1.92.995-4.735c-2.913.09-5.846.083-8.78-.027-.759 2.554-1.218 4.27-1.218 4.27z",
    fill: "#FF696A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.142.66c-.798-.127-1.749.946-2.749 2.712 1.342.2 2.682.389 4.02.571C35.322 2.041 34.95.788 34.142.66z",
    fill: "#D379FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.41 3.946c-1.341-.18-2.68-.368-4.02-.572-.688 1.212-1.398 2.757-2.099 4.472 2.001.048 4 .099 6.004.15.122-1.516.169-2.902.115-4.05z",
    fill: "#79D5FD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.296 7.997c-2-.048-3.999-.1-6.003-.15a102.493 102.493 0 00-1.729 4.546c2.39.151 4.78.318 7.17.49.242-1.688.437-3.352.562-4.886z",
    fill: "#96FD7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.687 18.004A268.688 268.688 0 0024.25 22.7c2.94.11 5.867.117 8.78.027.3-1.507.634-3.268.956-5.13-2.777.031-5.547.168-8.298.407z",
    fill: "#FF9F6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.99 17.597c.268-1.533.523-3.13.744-4.708a638.017 638.017 0 00-7.17-.49 182.666 182.666 0 00-1.876 5.61c2.75-.244 5.52-.38 8.303-.412z",
    fill: "#FFB531"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.094 50.438a.679.679 0 01-.679-.678v-1.986c0-.375.304-.678.679-.678.517 0 .998-.207 1.355-.583s.538-.868.511-1.387a1.87 1.87 0 00-3.736.1.679.679 0 11-1.357 0A3.227 3.227 0 0139.16 42a3.236 3.236 0 013.156 3.056 3.2 3.2 0 01-.882 2.391 3.243 3.243 0 01-1.661.933v1.38a.679.679 0 01-.68.678zM39.094 52.458a.679.679 0 01-.679-.678v-.023a.679.679 0 011.357 0v.023a.679.679 0 01-.678.678z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.364 24.303a1.17 1.17 0 01-1.17-1.17V19.71c0-.647.523-1.17 1.17-1.17.891 0 1.722-.357 2.337-1.005a3.2 3.2 0 00.881-2.392 3.23 3.23 0 00-3.151-3.05 3.224 3.224 0 00-3.29 3.223 1.17 1.17 0 01-2.341 0 5.564 5.564 0 015.678-5.562c2.9.058 5.291 2.372 5.441 5.268a5.519 5.519 0 01-1.52 4.124 5.59 5.59 0 01-2.865 1.608v2.38a1.17 1.17 0 01-1.17 1.17zM11.364 27.787a1.17 1.17 0 01-1.17-1.17v-.04a1.17 1.17 0 012.34 0v.04a1.17 1.17 0 01-1.17 1.17z",
    fill: "#FF9669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.33 23.834c0-1.97 1.597-2.54 3.568-2.54 1.97 0 3.567.57 3.567 2.54a3.568 3.568 0 11-7.135 0z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.337 25.4a2.081 2.081 0 100-4.162 2.081 2.081 0 000 4.162z",
    fill: "#030852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.009 22.592h10.37a.975.975 0 100-1.95h-10.37a.975.975 0 100 1.95z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.383 13.607a3.901 3.901 0 00-3.901 3.901v4.723h7.803v-4.723a3.902 3.902 0 00-3.902-3.901z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.547 13.782a3.906 3.906 0 00-2.738 3.726v4.723h-2.327v-4.723a3.902 3.902 0 015.065-3.726z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.153 14.394a5.461 5.461 0 110 10.922V14.394z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.377 27.433h-5.252a7.524 7.524 0 01-6.607 8.057c.107.505.164 1.027.164 1.565 0 3.342-7.522 7.774-7.87 7.221A24.892 24.892 0 013 31l.001-.218a7.48 7.48 0 013.263-1.198 7.524 7.524 0 017.361-9.09h9.477a3.276 3.276 0 013.275 3.275v3.664z",
    fill: "#69C0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.336 28.018c0 .537.058 1.061.165 1.566a7.525 7.525 0 00-6.177 10.055 8.537 8.537 0 00-.726.17A24.908 24.908 0 013 30.998l.001-.217a7.48 7.48 0 013.263-1.198 7.524 7.524 0 017.361-9.09h5.236a7.525 7.525 0 00-7.525 7.524z",
    fill: "#40A9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.132 34.072a1.42 1.42 0 01-1.42 1.42H48.2v1.643a3.008 3.008 0 01-3.01 3.011 3.011 3.011 0 01-3.004-2.816l-6.704.783a9.575 9.575 0 01-3.452 4.328 9.493 9.493 0 01-5.417 1.686c-5.27 0-9.544-4.274-9.544-9.543v-10.34h27.78a3.352 3.352 0 013.351 3.352v5.055h.512c.784 0 1.42.637 1.42 1.421z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.074 39.726V56H28c-3.349 0-6.543-.66-9.462-1.853-.273-.112-.544-.507-.812-.628-.293-.132-.583.009-.87-.134a25.111 25.111 0 01-8.938-7.493l9.152-21.647 11.004 15.48z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.296 38.783l-6.063 12.39a25.098 25.098 0 01-6.42-6.897l10.257-20.03 1.903 2.675.323 11.862z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.587 24.244a6.277 6.277 0 1012.555 0H5.587z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.266 29.357a1.136 1.136 0 110-2.273 1.136 1.136 0 010 2.273zM46.553 29.357a1.136 1.136 0 110-2.273 1.136 1.136 0 010 2.273z",
    fill: "#DC66C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.962 44.032c-.44.063-.89.095-1.349.095-5.27 0-9.543-4.273-9.543-9.544V24.244h2.692v10.34c0 4.814 3.566 8.796 8.2 9.448z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.286 23.834c0-1.97-1.598-3.054-3.568-3.054s-3.568 1.083-3.568 3.054a3.568 3.568 0 107.136 0z",
    fill: "#F9F6F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.377 25.4a2.081 2.081 0 100-4.162 2.081 2.081 0 000 4.162z",
    fill: "#030852"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.63 25.672h9.366v4.094h-9.367v-4.094z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.423 22.592h6.742a.975.975 0 000-1.95h-6.742a.975.975 0 100 1.95z",
    fill: "#ECF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.2 35.512v1.473c-.073-.01-1.468-.2-2.688.466a.73.73 0 01-.916-.182.729.729 0 01.205-1.098c1.368-.753 2.834-.711 3.4-.66z",
    fill: "#DC66C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.463 19.824a1.112 1.112 0 01-1.112-1.112V15.46c0-.614.498-1.112 1.112-1.112.847 0 1.636-.34 2.22-.955a3.04 3.04 0 00.838-2.272 3.07 3.07 0 00-2.995-2.897 3.063 3.063 0 00-3.125 3.062 1.112 1.112 0 11-2.224 0A5.286 5.286 0 0143.571 6c2.757.056 5.028 2.254 5.17 5.005a5.244 5.244 0 01-1.445 3.918 5.312 5.312 0 01-2.721 1.528v2.26c0 .614-.498 1.112-1.112 1.112zM43.463 23.134a1.112 1.112 0 01-1.112-1.112v-.037a1.112 1.112 0 112.224 0v.037c0 .614-.498 1.112-1.112 1.112zM16.501 52.18a1.038 1.038 0 01-1.038-1.038v-3.038c0-.573.465-1.038 1.038-1.038.792 0 1.528-.316 2.074-.89a2.839 2.839 0 00.782-2.122 2.866 2.866 0 00-2.796-2.705 2.86 2.86 0 00-2.919 2.858 1.038 1.038 0 11-2.076 0 4.936 4.936 0 015.036-4.934c2.574.052 4.695 2.105 4.828 4.673a4.895 4.895 0 01-1.35 3.659 4.96 4.96 0 01-2.54 1.426v2.11c0 .574-.465 1.039-1.039 1.039zM17.538 54.146a24.832 24.832 0 01-1.683-.761 1.038 1.038 0 011.683.762z",
    fill: "#FF9669"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "doubt_svg__clip0_2637_47691"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h56v56H0z"
  })))));
}

export default __webpack_public_path__ + "./fonts/doubt.3631f3aa23f54c580cc5aa3708769363.svg";
export { SvgDoubt as ReactComponent };